'use strict'

export default {
    get(handle, handles, opts) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'GET',
                url: '/api/banner-ads/assets',
                headers: {
                    'content-type': 'application/json'
                },
                params: {
                    ...{
                        slot_handle: handle,
                        slot_handles: handles
                    },
                    ...opts
                }
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Banners.js